import { Col, Modal, Row } from 'antd';
import classNames from 'classnames/bind';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SVGS } from '~/assets/assetsPath';
import config from '~/config';
import { navCardAboutMe } from '~/constants';
import { handleLogout } from '~/store/actions/UserAction';
import LogOutModal from '../form-log-out';
import styles from './CardAboutMe.module.scss';
import Dropdown from './dropdown';
const cx = classNames.bind(styles);

const CardAboutMe = ({ tabIndex }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [tab, setTab] = useState(tabIndex.parent);
    const stayTab = tabIndex.parent;
    const [dropdown, setDropdown] = useState(tabIndex.children >= 0 ? true : false);

    const handleChangeTab = (item, index) => {
        if (item.children.length === 0) {
            navigate(item.path);
        } else {
            if (index === tab) {
                setDropdown(!dropdown);
            } else {
                setDropdown(true);
            }
        }
        setTab(index);
    };

    const [isShowLogOut, setIsShowLogOut] = useState(false);
    const onCancel = () => {
        setIsShowLogOut(false);
    };
    const handleShowLogOut = () => {
        setIsShowLogOut(true);
    };

    const onLogOut = () => {
        try {
            dispatch(handleLogout());
            setIsShowLogOut(false);
            navigate(config.routes.home);
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                {navCardAboutMe?.map((item, index) => {
                    return (
                        <div key={index}>
                            <Row
                                className={cx('item_normal', { item_selected: tab === index })}
                                align="middle"
                                onClick={() => handleChangeTab(item, index)}
                            >
                                <Col xs={20} className={cx('icon_tab')}>
                                    <img src={tab === index ? item.iconActive : item.icon} alt="" />
                                    <span className={cx('text')}>{item.text}</span>
                                </Col>
                                <Col xs={4}>
                                    {item?.children.length ? (
                                        <img
                                            src={
                                                tab === index
                                                    ? dropdown
                                                        ? SVGS.IconArrowUpSelected
                                                        : SVGS.IconArrowDownSelected
                                                    : SVGS.IconArrowDown
                                            }
                                            alt=""
                                        />
                                    ) : (
                                        <></>
                                    )}
                                </Col>
                            </Row>
                            {tab === index && dropdown && (
                                <Dropdown
                                    stayTab={stayTab}
                                    tab={tab}
                                    subTab={tabIndex?.children}
                                    items={item?.children}
                                    setDropdown={setDropdown}
                                />
                            )}
                        </div>
                    );
                })}
                <Row justify="center">
                    <div className={cx('btn_logout')} onClick={handleShowLogOut}>
                        Log out
                    </div>
                </Row>
            </div>
            {isShowLogOut && (
                <Modal
                    centered
                    visible={isShowLogOut}
                    onCancel={onCancel}
                    maskClosable={false}
                    footer={null}
                    className="otp-modal"
                    width={480}
                >
                    <div style={{ padding: '30px 10px 0px 10px' }}>
                        <LogOutModal onCancel={onCancel} onLogOut={onLogOut} />
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default CardAboutMe;
